/**
 * Error personalizado para sesión expirada o token inválido.
 * Se lanza cuando la API responde con statusCode 422 o 500
 * indicando que el código de seguridad no es válido o ha caducado.
 */
export class SessionExpiredError extends Error {
  constructor(statusCode, serverMessage) {
    super(
      serverMessage ||
        'Su sesión ha expirado o el tiempo límite permitido ha caducado.'
    );
    this.name = 'SessionExpiredError';
    this.statusCode = statusCode;
  }
}
